<template>
  <div class="note login-model" :style="note">
    <div class="login-ui" style="display:flex">
      <div class="logo">
        <img src="../../assets/img/logo.png">
      </div>
      <div class="form-box">
        <span class="icon-tops"></span>
        <a-form @submit="handleSubmit" :form="form">
          <template v-if="form">
            <a-col :span="16" :offset="4">
              <a-form-item :validateStatus="userNameError() ? 'error' : ''" :help="userNameError() || ''">
                <!-- <span class="myLogin-icon">
                  <img src="../../assets/img/user.png">
                </span> -->
                <a-input placeholder="请输入登录账号" v-decorator="['userName',{rules: [{ required: true, message: '请输入登录账号' }]}]" class="login-input-st" autocomplete="off">
                  <!-- <span class="myLogin-icon"><img src="../../assets/img/user.png"/></span> -->
                  <a-icon slot="prefix" type='user' style="color:rgba(255,255,255,1)" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="16" :offset="4">
              <a-form-item :validateStatus="passwordError() ? 'error' : ''" :help="passwordError() || ''">
                <!-- <span class="myLogin-icon">
                  <img src="../../assets/img/psw.png">
                </span> -->
                <a-input type="password" placeholder="请输入密码" v-decorator="['password',{rules: [{ required: true, message: '请输入密码' }]}]" class="login-input-st">
                  <a-icon slot="prefix" type='lock' style="color:rgba(255,255,255,1)" />
                </a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :span='16' :offset='3'>
        <a-form-item
        :validateStatus="VaildCodeError() ? 'error' : ''"
          :help="VaildCodeError() || ''"
          fieldDecoratorId="vaild"
          :fieldDecoratorOptions="{rules: [{  message: '请输入验证码' },{validator:this.ValidCodeTrue,message:'请输入正确的验证码'}]}"
          >
            <a-input type="text"  @keyup.enter.native="onSubmit()" placeholder="验证码" auto-complete="off" class="login-input-st">
            </a-input>
            <img :src="valid.img" alt="" @click="getAuth"  />
          </a-form-item>
            </a-col>-->
            <a-col :span="16" :offset="4">
              <a-form-item>
                <!-- <p class="forget-pwd"><a href="http://www.baidu.com">忘记密码?</a></p> -->
                <a-button type="primary" htmlType="submit" :disabled="hasErrors(form.getFieldsError()) || this.loading" style="width:100%" class="login-input-st myself-btn">{{this.loading?"正在登录":"登录"}}</a-button>
              </a-form-item>
            </a-col>
          </template>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { api } from "@/common";
import config from "../../config";
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}
export default {
  data() {
    return {
      hasErrors,
      form: this.$form.createForm(this),
      loading: false,
      loginInfo: {
        userName: "",
        password: ""
        //valid:'',
      },
      valid: {
        code: "",
        img: ""
      },
      note: {
        backgroundImage: "url(" + require("../../assets/img/bg.png") + ")",
        backgroundRepeat: "no-repeat",
        height: "100%",
        width: "100%",
        backgroundSize: "cover"
      }
    };
  },
  mounted() {
    this.checkHasLogin();
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
    // this.getAuth();
  },
  methods: {
    checkHasLogin() {
      if (
        sessionStorage.getItem("user") &&
        sessionStorage.getItem("token") &&
        sessionStorage.getItem("expireTime") &&
        sessionStorage.getItem("menus") &&
        sessionStorage.getItem("permission") &&
        sessionStorage.getItem("expireTime") > moment().valueOf()
      ) {
        this.$router.push({ name: "main" });
      } else {
        sessionStorage.clear();
      }
    },

    async getAuth() {
      let data = await api.getAuthImg();
      if (data) {
        this.valid.code = data.authCode;
        this.valid.img = `data:image/jpeg;base64,${data.imageStream}`;
      }
    },
    async onSubmit(loginInfo) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.loginInfo = loginInfo;
      let data = await api.login(this.loginInfo);
      this.loading = false;
      if (data) {
        sessionStorage.setItem("token", data.accessToken);
        sessionStorage.setItem(
          "expireTime",
          new Date().valueOf() + data.expireInSeconds * 1000
        );

        sessionStorage.setItem(
          "user",
          JSON.stringify({
            userType: data.userType,
            userId: data.userId,
            userName: data.userName,
            name: data.name,
            avatar: data.userAvatar
          })
        );

        let dataMenus = await api.GetGrantedPermission();
        let menus = this.pickMenu(dataMenus || []);
        sessionStorage.setItem("menus", JSON.stringify(menus));
        let a = dataMenus.filter(item => item.description == "O");
        sessionStorage.setItem("permission", JSON.stringify(a));
        this.loginInfo.accountName = "";
        this.loginInfo.password = "";
        this.$router.push({ name: "main" });
      }
    },
    pickMenu(menus = []) {
      let pages = config.pages;
      let modulePage = config.modulePage;
      let discount = [];
      menus
        .filter(n => n.description == "R")
        .forEach(item => {
          let tm = modulePage.filter(n => n.name == item.name);
          if (tm[0]) {
            if (tm[0].submenus) {
              tm[0].submenus = [];
            }
            discount.push(tm[0]);
          }
        });
      menus
        .filter(n => n.description == "M")
        .forEach(item => {
          let tm = pages.filter(n => n.name == item.name);
          if (tm && tm[0]) {
            let ptm = discount.findIndex(tim => {
              return tim.name == tm[0].parentName;
            });
            if (ptm >= 0) {
              discount[ptm].submenus.push(tm[0]);
            }
          }
        });
      discount.unshift({
        displayName: "工作台",
        icon: "gongzuotaicopy",
        name: "workbench",
        parentName: "",
        submenus: [
          {
            parentName: "workbench",
            name: "homepage",
            displayName: "首页",
            description: "M",
            linkUrl: "/index",
            icon: ""
          }
        ]
      });
      return discount;
    },
    // Only show error after a field is touched.
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },

    VaildCodeError() {
      const { getFieldError, isFieldTouched, getFieldValue } = this.form;
      return isFieldTouched("valid") && getFieldError("valid");
    },
    ValidCodeTrue(rule, value, callback) {
      const { getFieldValue } = this.form;
      if (this.valid.code && this.valid.code !== getFieldValue("vaild")) {
        callback("验证码错误");
      }
      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.onSubmit(values);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-model {
  .ant-input-affix-wrapper .ant-input:not(:first-child) {
    border-radius: 0;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
  }
  .ant-input-affix-wrapper .ant-input-prefix {
    left: 18px !important;
  }
  .ant-form-explain,
  .ant-form-extra {
    padding-left: 18px;
  }
  .myLogin-icon {
    position: absolute;
    z-index: 9999;
    left: 16px;
    top: -14px;
    img {
      width: 20px;
    }
  }
  .logo {
    //width: 400px;
    // height: 36px;
    // background: url("../../assets/img/logo.png") no-repeat;
    margin: 10px auto;
    text-align: center;
    margin-bottom: 50px;
    img {
      width: 80%;
    }
  }
}

.login-ui {
  position: absolute;
  width: 500px;
  height: 400px;
  left: 50%;
  top: 30%;
  margin-left: -250px;
  margin-top: -200px;
  flex-direction: column;
  display: flex;
  // background-image: url("../../assets/img/login.png");
  // background-size: contain;
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
}
.form-box {
  background: rgba(255, 255, 255, 0.1);

  position: relative;
  border-radius: 10px;
  padding-top: 40px;
  padding-bottom: 40px;
  .icon-tops {
    width: 0;
    height: 0;
    border-width: 0 20px 20px;
    border-style: solid;
    border-color: transparent transparent rgba(255, 255, 255, 0.1); /*透明 透明  灰*/
    position: absolute;
    top: 0;
    left: calc(50% - 10px);
    top: -20px;
  }
}
a-input {
  border-radius: 0;
}
.login {
  width: 100%;
  height: 100%;
}

.login-ui .login-input-st {
  padding: 6px 11px;
  height: 40px;
  font-size: 16px;
  border-radius: 0;
  // background: rgba(255,255,255,.2)
}
.myself-btn {
  background: #fff !important;
  color: #000;
  border: 0;
  border-radius: 0;
}

// 改的样式

.form-box {
  position: relative;
  background: #fff;
  padding-top: 50px !important;
  border-radius: 6px !important;
}
.ant-input {
  background: #f2f2f2 !important;
  color: #6d6d6d !important;
  border-color: #f2f2f2 !important;
}
.ant-row {
  margin-top: 8px !important;
}
svg[data-icon] {
  color: #a0a0a0 !important;
  position: relative;
  top: 6px;
}
.myself-btn {
  transition: 0.2s all linear;
  background: #06e2af !important;
  background: linear-gradient(to right, #06e2af, #03b98f) !important;
  border-radius: 10px !important;
  color: #fff !important;
  width: 333px !important;
  height: 50px !important;
  position: absolute;
  bottom: -80px;
  left: 0;
}
.myself-btn:hover {
  color: #fff !important;
  background: linear-gradient(to right, #00c99b, #00a781) !important;
}

.forget-pwd {
  height: 18px;
}
.forget-pwd a {
  height: 100%;
  float: left;
  line-height: normal !important;
  margin-left: 12px;
  text-decoration: underline;
  color: #000;
}
</style>




// WEBPACK FOOTER //
// src/router/login/login.vue